import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Svg } from "./Svg";

const BaseButtonStyle = styled.button`
    border: none;
    cursor: pointer;
    border-radius: 2px;
    color: ${props => props.theme.white};
    transition: background-color 0.3s, color 0.3s;
    background-color: ${props => props.theme.primaryLight};

    &:hover {
        background-color: ${props => props.theme.primaryLighter};
    }
    &:disabled {
        background-color: ${props => props.theme.greyLight};
    }
    &:focus-visible {
        outline: 1px solid ${props => props.theme.primaryLight};
    }
`;

const NormalStyle = styled(BaseButtonStyle)`
    height: 28px;
    display: flex;
    padding: 0 12px;
    align-items: center;
    white-space: nowrap;
    justify-content: center;
    >div {
        margin-left: 6px;
        user-select: none;
    }
`;

const CompactStyle = styled(BaseButtonStyle)`
    width: 25px;
    padding: 5px;
    margin-left: 2px;
    height: 24px!important;
`;


export const Button = React.memo(props => {

    const { id, name, value, disabled, svgIcon, simulateLoading, compact } = props;
    const [loading, setLoading] = useState(props.loading);

    useEffect(() => {
        setLoading(props.loading);
    }, [props.loading]);

    const onClick = event => {
        if (simulateLoading) {
            setLoading(true);
            setTimeout(() => setLoading(false), 3000);
        }
        props.onClick(event);
    };

    const ButtonStyle = compact ? CompactStyle : NormalStyle;

    return (
        <ButtonStyle
            id={id}
            name={name}
            onClick={onClick}
            disabled={disabled || loading}>
            {svgIcon &&
                <Svg path={svgIcon} loading={loading} size="15" />
            }
            {value &&
                <div>{value}</div>
            }
        </ButtonStyle>
    );
});